(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frontrow-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__twFrontrowStickersReady) return;
    window.__twFrontrowStickersReady = true;
    function ping(iframe) {
      try {
        var parentWidth = iframe.parentElement ? iframe.parentElement.offsetWidth : 0;
        var zoom = parentWidth && iframe.offsetWidth ? (parentWidth * 0.9) / iframe.offsetWidth : 1;
        iframe.contentWindow.postMessage({ name: 'PARENT_READY' }, '*');
        iframe.contentWindow.postMessage({ name: 'STICKER_RESIZED', data: { zoom: zoom } }, '*');
      } catch (e) {}
    }
    function watch(iframe) {
      if (iframe.dataset.twFrPing) return;
      iframe.dataset.twFrPing = '1';
      iframe.addEventListener('load', function () {
        ping(iframe);
      });
    }
    function pingAll() {
      document.querySelectorAll('.iframe-frontrow-sticker').forEach(function (iframe) {
        watch(iframe);
        ping(iframe);
      });
    }
    pingAll();
    document.addEventListener('DOMContentLoaded', pingAll);
    window.addEventListener('load', pingAll);
    window.addEventListener('message', function (ev) {
      var name = ev.data && ev.data.name;
      if (name === 'STICKER_REQUEST_READY_STATUS') {
        try {
          ev.source.postMessage({ name: 'PARENT_READY' }, '*');
        } catch (e) {}
      }
      if (name === 'RESIZE_STICKER') {
        document.querySelectorAll('.iframe-frontrow-sticker').forEach(function (iframe) {
          if (iframe.contentWindow === ev.source) ping(iframe);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-pdp-starter-kit"] && !Shopify.designMode) return;
  try {
    (function () {
  function hid(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = name; i.value = value;
    return i;
  }
  function addProps(form, prefix, obj) {
    for (var k in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, k)) {
        form.appendChild(hid(prefix + '[' + k + ']', obj[k]));
      }
    }
  }
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // Wire one Starter Kit block: read its bundle payload and take over its own
  // add-to-cart form so the whole bundle (with discount properties) is added.
  function wire(block) {
    var fsEl = block.querySelector('.fs-bundle');
    var form = block.querySelector('[data-tw-starter-kit-form]');
    // No bundle payload -> leave the native form alone (adds the parent product).
    if (!fsEl || !form || form.__fsBundle) return;

    var items;
    try { items = JSON.parse(fsEl.getAttribute('data-fs-items') || '[]'); } catch (e) { return; }
    if (!items.length) return;

    var attrs;
    try { attrs = JSON.parse(fsEl.getAttribute('data-fs-attributes') || 'null'); } catch (e) { attrs = null; }
    var ret = fsEl.getAttribute('data-fs-return') || '';
    form.__fsBundle = true;

    // Disable the native inputs and append the bundle items (fallback for a
    // native submit); the fetch below is the primary path (no page redirect).
    var natives = form.querySelectorAll('[name="id"], [name="quantity"], [name="selling_plan"], [name^="properties["], [name^="items["]');
    for (var i = 0; i < natives.length; i++) natives[i].disabled = true;

    var first = items[0];
    form.appendChild(hid('id', first.id));
    form.appendChild(hid('quantity', first.quantity == null ? 1 : first.quantity));
    if (first.selling_plan) form.appendChild(hid('selling_plan', first.selling_plan));
    if (first.properties) addProps(form, 'properties', first.properties);
    for (var n = 1; n < items.length; n++) {
      var it = items[n];
      form.appendChild(hid('items[' + n + '][id]', it.id));
      form.appendChild(hid('items[' + n + '][quantity]', it.quantity == null ? 1 : it.quantity));
      if (it.selling_plan) form.appendChild(hid('items[' + n + '][selling_plan]', it.selling_plan));
      if (it.properties) addProps(form, 'items[' + n + '][properties]', it.properties);
    }

    function onAdd(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (form.__fsAdding) return;
      form.__fsAdding = true;
      var payload = { items: items.map(function (it) {
        var o = { id: it.id, quantity: it.quantity == null ? 1 : it.quantity };
        if (it.selling_plan) o.selling_plan = it.selling_plan;
        if (it.properties) o.properties = it.properties;
        return o;
      }) };
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { window.alert((res.j && res.j.description) || 'Could not add the bundle to your cart.'); return; }
          function done() { if (ret) { window.location.assign(ret); } }
          if (attrs) {
            fetch(root() + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: attrs })
            }).then(done, done);
          } else { done(); }
        })
        .catch(function () { window.alert('Could not add the bundle to your cart.'); })
        .then(function () { form.__fsAdding = false; });
    }

    // Intercept in the capture phase so the theme's <product-form> submit
    // handler is bypassed (its handler never runs once we stop propagation).
    var btn = form.querySelector('[data-tw-starter-kit-cta], [type="submit"], button[name="add"]');
    if (btn) btn.addEventListener('click', onAdd, true);
    form.addEventListener('submit', onAdd, true);
  }

  function run() {
    var blocks = document.querySelectorAll('[data-tw-starter-kit]');
    for (var i = 0; i < blocks.length; i++) wire(blocks[i]);
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run)
    : run();
})();
  } catch(e) { console.error(e); }
})();

})();
